import {NamedRouting} from "@/domain/utils/NamedRouting";

export class Link {
  constructor(public readonly routing: NamedRouting,
              public readonly text: string,
              public readonly code: string) {
  }
}